import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const InvoiceCompo = () => {
  return (
    <>
      <InvoiceMain>Billing</InvoiceMain>
      <InvoiceToggle>
        <li>
          <Link to="/billing">
            <span className="color">Overview</span>
          </Link>
        </li>
        <li>
          <Link to="/billing">
            <span className="color">Invoices</span>
          </Link>
        </li>
      </InvoiceToggle>
      <Border></Border>
      <InvoiceHead>
        <h3>Invoice</h3>
        <div className="flexSpace">
          <span>Export to</span>
          <div className="flex">
            <button>PDF</button>
            <button>CSV</button>
          </div>
        </div>
      </InvoiceHead>
      <InvoiceCard>
        <InvoiceCenter>
          <InvoiceGrid>
            <InvoiceBox>
              <div>
                <h3>Running Total</h3>
                <h5>$0.00</h5>
              </div>
              <div>
                <h3>Previous Invoice</h3>
                <span>N/A</span>
              </div>
            </InvoiceBox>
            <BorderCard></BorderCard>
            <InvoiceBox>
              <div>
                <h3>Billing Period</h3>
                <p>05/01/23 - 06/01/23</p>
              </div>
              <div>
                <h3>Invoice Number</h3>
                <p>645c564ab6f364466ae917f9</p>
              </div>
            </InvoiceBox>
          </InvoiceGrid>
        </InvoiceCenter>
      </InvoiceCard>
      <InvoiceCard>
        <ServiceData>
          <InvoiceHead>
            <h2>Service Summary</h2>
            <div className="btn">
              <button>Download Csv</button>
            </div>
          </InvoiceHead>
          <div className="grid">
            <div>
              <h3>Description</h3>
            </div>
            <div>
              <h3>Unit Price</h3>
            </div>
            <div>
              <h3>Usage</h3>
            </div>
          </div>
          <div className="gridData">
            <div>
              <h3>Plan - Business</h3>
            </div>
            <div></div>
            <div>
              <h3>₹1500/mo</h3>
            </div>
          </div>
          <div className="grid">
            <div>
              <h3>Usage Total</h3>
            </div>
            <div></div>
            <div>
              <h3>₹1500/mo</h3>
            </div>
          </div>
        </ServiceData>
      </InvoiceCard>
      <InvoiceCard>
        <PaymentData>
          <InvoiceHead>
            <h2>Payment Details</h2>
            <div className="btn">
              <button>Download Csv</button>
            </div>
          </InvoiceHead>
          <div className="grid">
            <div>
              <h3>Payment Method</h3>
            </div>
            <div>
              <h3>Date</h3>
            </div>
            <div>
              <h3>Status</h3>
            </div>
            <div>
              <h3>Total</h3>
            </div>
            <div>
              <h3>Amount Due</h3>
            </div>
            <div>
              <h3>Action</h3>
            </div>
          </div>
          <div className="grid">
            <div>
              <h3>Total Amount</h3>
            </div>
          </div>
        </PaymentData>
      </InvoiceCard>
    </>
  );
};

export default InvoiceCompo;

const InvoiceMain = styled.h3`
  font-weight: 500;
  font-size: 35px;
  font-family: "Source Serif Pro", serif;
  color: rgb(0, 104, 74);
`;

const InvoiceToggle = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    cursor: pointer;
    position: relative;
    list-style: none;
    margin-right: 25px;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 17px;
      text-align: center;
      margin-left: 18px;

      &:hover {
        color: rgb(28, 45, 56);
      }
    }
    margin-top: 20px;
  }

  .colorActive {
    color: #c1c7c6;
  }
  .color {
    color: #c1c7c6;
  }

  .borderActive {
    position: absolute;
    top: 120%;
    left: 0%;
    background-color: rgb(28, 45, 56);
    height: 3px;
    width: 110px;
  }
`;

const Border = styled.div`
  background-color: #cfcece;
  height: 3px;
  margin-top: 5px;
  width: 100%;
`;

const InvoiceHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  h3 {
    font-weight: 500;
    font-size: 22px;
    margin-top: 1rem;
  }
  .flexSpace {
    display: flex;
    margin-top: 1rem;
    span {
      font-weight: 400;
      font-size: 18px;
      margin-right: 10px;
    }
    button {
      border: none;
      outline: none;
      border: 1px solid rgb(28, 45, 56);
      padding: 2px 10px;
      cursor: pointer;

      &:nth-child(1) {
        border-radius: 5px 0px 0px 5px;
      }
      &:nth-child(2) {
        border-left: none;
        border-radius: 0px 5px 5px 0px;
      }
    }
  }
  .btn {
    button {
      border: none;
      outline: none;
      border: 1px solid rgb(28, 45, 56);
      padding: 2px 10px;
      cursor: pointer;
      border-radius: 5px;
      font-weight: 500;
    }
  }
`;

const InvoiceCard = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;
  /* width: 70%; */
  padding: 20px 20px;
`;

const InvoiceCenter = styled.div`
  position: relative;
  width: 45%;
`;

const InvoiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
`;

const InvoiceBox = styled.div`
  margin-top: 0.7rem;
  div {
    line-height: 20px;
    margin-bottom: 1.2rem;
    h3 {
      font-size: 14px;
      font-weight: 600;
    }
    p {
      font-size: 14px;
      font-weight: 400;
    }
    h5 {
      font-weight: 600;
      font-size: 19px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

const BorderCard = styled.div`
  position: absolute;
  left: 38%;
  background-color: #cfcece;
  height: 100%;
  width: 1px;
`;

const ServiceData = styled.div`
  h2 {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 1rem;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    border-bottom: 1px solid #cfcece !important;

    h3 {
      font-weight: 600;
      font-size: 14px;
      padding: 5px 0px;
    }
  }
  .gridData {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    border-bottom: 1px solid rgb(0, 30, 43) !important;

    h3 {
      font-weight: 500;
      font-size: 14px;
      padding: 5px 0px;
      color: rgb(0, 104, 74);
    }
  }
`;

const PaymentData = styled.div`
  h2 {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 1rem;
  }
  .grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
    border-bottom: 2px solid #cfcece !important;

    h3 {
      font-weight: 600;
      font-size: 14px;
      padding: 5px 0px;
    }
  }
`;
